module.exports = __webpack_public_path__ + "static/media/biomarker_forest.586eb829.png";